var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"footer"}},[(_vm.gameOver)?_c('h1',{attrs:{"id":"winner"}},[_vm._v(_vm._s(_vm.display))]):_vm._e(),(_vm.gameOver)?_c('button',{on:{"click":_vm.emitNewGame}},[_vm._v("new game")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }